import styled from 'styled-components/macro';

export const SubRouteNavBarOption = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 147px;
  height: 100%;
  z-index: 2;
  background-color: ${({ colorPrimary }) => colorPrimary || 'transparent'};
  font-size: ${({ theme }) => theme.h5}px;
  font-family: ${({ theme }) => theme.primaryFont};
  border-style: none;
  color: ${({ textColor, theme }) => textColor || theme.light};
  ${({ isSelected, contrastColor }) =>
    isSelected && contrastColor ? `color: ${contrastColor};` : ''};
  text-transform: capitalize;
  padding: 10px;
  transition: color 0.3s;
  &::-moz-focus-inner {
    border: 0;
  }
  a {
    display: flex;
    align-items: center;
    color: ${({ isActive, secondaryColor }) =>
      isActive && secondaryColor ? secondaryColor : 'inherit'};
    height: 100%;
    padding: 0 20px 0 20px;
    & > svg {
      margin: 0px;
      fill: ${({ textColor, theme }) => textColor || theme.light};
      ${({ isSelected, contrastColor }) =>
        isSelected && contrastColor ? `fill: ${contrastColor};` : ''}
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    min-width: 0px;
    flex-grow: 1;
    a {
      padding: 0px;
    }
  }
`;
